import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap"

export default class extends Controller {
  connect() {
    bootstrap.Toast.getOrCreateInstance(this.element).show()
  }
}
